import { render, staticRenderFns } from "./EmpresaCombo.vue?vue&type=template&id=36cf74fe&scoped=true"
import script from "./EmpresaCombo.vue?vue&type=script&lang=js"
export * from "./EmpresaCombo.vue?vue&type=script&lang=js"
import style0 from "./EmpresaCombo.vue?vue&type=style&index=0&id=36cf74fe&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cf74fe",
  null
  
)

export default component.exports